export default function AirConditioner() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_6398)">
                <path
                    d="M34.5 21H13.5C12.6716 21 12 21.6716 12 22.5V27H36V22.5C36 21.6716 35.3284 21 34.5 21Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M41.25 9H6.75C5.50736 9 4.5 10.0074 4.5 11.25V24.75C4.5 25.9926 5.50736 27 6.75 27H41.25C42.4926 27 43.5 25.9926 43.5 24.75V11.25C43.5 10.0074 42.4926 9 41.25 9Z"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M31.5 13.5H35.5" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M16.35 30L15.1472 31.7182C14.6283 32.4596 14.7165 33.4665 15.3563 34.1063V34.1063C16.0126 34.7626 16.0864 35.8015 15.5296 36.5439L14.25 38.25"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                />
                <path
                    d="M24.6 30L23.3972 31.7182C22.8783 32.4596 22.9665 33.4665 23.6063 34.1063V34.1063C24.2626 34.7626 24.3364 35.8015 23.7796 36.5439L22.5 38.25"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                />
                <path
                    d="M32.85 30L31.6472 31.7182C31.1283 32.4596 31.2165 33.4665 31.8563 34.1063V34.1063C32.5126 34.7626 32.5864 35.8015 32.0296 36.5439L30.75 38.25"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_845_6398">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
